import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef();
  const [activeDropdown, setActiveDropdown] = useState(null);

  // Menü açıkken dışarı tıklanınca kapansın
  useEffect(() => {
    if (!menuOpen) return;
    const handleClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [menuOpen]);

  // Linke tıklanınca menü kapansın (mobilde)
  const handleLinkClick = () => {
    setMenuOpen(false);
    setActiveDropdown(null);
  };

  // Dropdown menüyü aç/kapa
  const toggleDropdown = (dropdown) => {
    setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
  };

  // Hover için
  const handleMouseEnter = (dropdown) => {
    if (window.innerWidth > 900) {
      setActiveDropdown(dropdown);
    }
  };

  const handleMouseLeave = () => {
    if (window.innerWidth > 900) {
      setActiveDropdown(null);
    }
  };

  // Her dropdown için hangi path'leri içerdiğini kontrol et
  const isDropdownActive = (dropdownName) => {
    const dropdownPaths = {
      'tools': ['/json-beautifier', '/json-escape-unescape', '/json-compare', '/json-path-finder'],
      'schema': ['/schema-validator', '/json-to-schema'],
      'html': ['/html-beautifier', '/html-viewer', '/html-escape-unescape', '/markdown-viewer'],
      'basic-tools': ['/notepad', '/lorem-ipsum', '/letter-count', '/x-counter', '/dummy-files'],
      'encoders': ['/base64-encoder', '/url-encoder', '/jwt-decoder', '/hash-generator'],
      'generators': ['/uuid-generator', '/password-generator', '/qr-code-generator'],
      'dev-tools': ['/http-status-checker', '/regex-tester', '/text-diff-checker', '/text-replacer', '/javascript-compressor', '/css-compressor', '/csharp-to-json'],
      'ai': ['/json-to-toon', '/template-prompts']
    };

    return dropdownPaths[dropdownName]?.includes(currentPath) || false;
  };

  return (
    <div style={{ background: '#333', width: '100%', boxSizing: 'border-box' }}>
      <nav className="navbar-responsive" style={{ maxWidth: '1600px', width: '100%', margin: '0 auto', padding: '0.5rem 1rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxSizing: 'border-box', position: 'relative' }}>
        <Link to="/" style={{ color: '#61DAFB', fontSize: '1.5rem', textDecoration: 'none', fontWeight: 700, letterSpacing: '1px' }}>
          YourJSONTools
        </Link>
        <button className="navbar-hamburger" aria-label="Menu" onClick={() => setMenuOpen(!menuOpen)}>
          <span style={{ display: 'block', width: 24, height: 3, background: '#fff', margin: '5px 0', borderRadius: 2 }}></span>
          <span style={{ display: 'block', width: 24, height: 3, background: '#fff', margin: '5px 0', borderRadius: 2 }}></span>
          <span style={{ display: 'block', width: 24, height: 3, background: '#fff', margin: '5px 0', borderRadius: 2 }}></span>
        </button>
        <div ref={menuRef} className={`navbar-links${menuOpen ? ' open' : ''}`}>
          
          {/* JSON Tools Dropdown */}
          <div 
            className="dropdown-container" 
            onMouseEnter={() => handleMouseEnter('tools')}
            onMouseLeave={handleMouseLeave}
          >
            <div
              className={`dropdown-trigger ${activeDropdown === 'tools' || isDropdownActive('tools') ? 'active' : ''}`}
              onClick={() => toggleDropdown('tools')}
            >
              JSON Tools
              <span className="dropdown-arrow">▼</span>
            </div>
            <div className={`dropdown-menu ${activeDropdown === 'tools' ? 'active' : ''}`}>
              <Link to="/json-beautifier" className={currentPath === '/json-beautifier' ? 'active' : ''} onClick={handleLinkClick}>JSON Beautifier</Link>
              <Link to="/json-escape-unescape" className={currentPath === '/json-escape-unescape' ? 'active' : ''} onClick={handleLinkClick}>JSON Escape</Link>
              <Link to="/json-compare" className={currentPath === '/json-compare' ? 'active' : ''} onClick={handleLinkClick}>JSON Compare</Link>
              <Link to="/json-path-finder" className={currentPath === '/json-path-finder' ? 'active' : ''} onClick={handleLinkClick}>JSON Path Finder</Link>
            </div>
          </div>
          
          {/* JSON Schema Dropdown */}
          <div 
            className="dropdown-container" 
            onMouseEnter={() => handleMouseEnter('schema')}
            onMouseLeave={handleMouseLeave}
          >
            <div
              className={`dropdown-trigger ${activeDropdown === 'schema' || isDropdownActive('schema') ? 'active' : ''}`}
              onClick={() => toggleDropdown('schema')}
            >
              JSON Schema
              <span className="dropdown-arrow">▼</span>
            </div>
            <div className={`dropdown-menu ${activeDropdown === 'schema' ? 'active' : ''}`}>
              <Link to="/schema-validator" className={currentPath === '/schema-validator' ? 'active' : ''} onClick={handleLinkClick}>Schema Validator</Link>
              <Link to="/json-to-schema" className={currentPath === '/json-to-schema' ? 'active' : ''} onClick={handleLinkClick}>JSON to Schema</Link>
            </div>
          </div>
          
          {/* HTML Dropdown */}
          <div 
            className="dropdown-container" 
            onMouseEnter={() => handleMouseEnter('html')}
            onMouseLeave={handleMouseLeave}
          >
            <div
              className={`dropdown-trigger ${activeDropdown === 'html' || isDropdownActive('html') ? 'active' : ''}`}
              onClick={() => toggleDropdown('html')}
            >
              HTML
              <span className="dropdown-arrow">▼</span>
            </div>
            <div className={`dropdown-menu ${activeDropdown === 'html' ? 'active' : ''}`}>
              <Link to="/html-beautifier" className={currentPath === '/html-beautifier' ? 'active' : ''} onClick={handleLinkClick}>HTML Beautifier</Link>
              <Link to="/html-viewer" className={currentPath === '/html-viewer' ? 'active' : ''} onClick={handleLinkClick}>HTML Viewer</Link>
              <Link to="/html-escape-unescape" className={currentPath === '/html-escape-unescape' ? 'active' : ''} onClick={handleLinkClick}>HTML Escape</Link>
              <Link to="/markdown-viewer" className={currentPath === '/markdown-viewer' ? 'active' : ''} onClick={handleLinkClick}>Markdown Viewer</Link>
            </div>
          </div>

          {/* Basic Tools Dropdown */}
          <div 
            className="dropdown-container dropdown-right" 
            onMouseEnter={() => handleMouseEnter('basic-tools')}
            onMouseLeave={handleMouseLeave}
          >
            <div
              className={`dropdown-trigger ${activeDropdown === 'basic-tools' || isDropdownActive('basic-tools') ? 'active' : ''}`}
              onClick={() => toggleDropdown('basic-tools')}
            >
              Basic Tools
              <span className="dropdown-arrow">▼</span>
            </div>
            <div className={`dropdown-menu dropdown-menu-right ${activeDropdown === 'basic-tools' ? 'active' : ''}`}>
              <Link to="/notepad" className={currentPath === '/notepad' ? 'active' : ''} onClick={handleLinkClick}>Online Notepad</Link>
              <Link to="/lorem-ipsum" className={currentPath === '/lorem-ipsum' ? 'active' : ''} onClick={handleLinkClick}>Lorem Ipsum</Link>
              <Link to="/letter-count" className={currentPath === '/letter-count' ? 'active' : ''} onClick={handleLinkClick}>Letter Count</Link>
              <Link to="/x-counter" className={currentPath === '/x-counter' ? 'active' : ''} onClick={handleLinkClick}>X Counter</Link>
              <Link to="/dummy-files" className={currentPath === '/dummy-files' ? 'active' : ''} onClick={handleLinkClick}>Dummy Files</Link>
            </div>
          </div>
          
          {/* Encoders Dropdown */}
          <div 
            className="dropdown-container dropdown-right" 
            onMouseEnter={() => handleMouseEnter('encoders')}
            onMouseLeave={handleMouseLeave}
          >
            <div
              className={`dropdown-trigger ${activeDropdown === 'encoders' || isDropdownActive('encoders') ? 'active' : ''}`}
              onClick={() => toggleDropdown('encoders')}
            >
              Encoders
              <span className="dropdown-arrow">▼</span>
            </div>
            <div className={`dropdown-menu dropdown-menu-right ${activeDropdown === 'encoders' ? 'active' : ''}`}>
              <Link to="/base64-encoder" className={currentPath === '/base64-encoder' ? 'active' : ''} onClick={handleLinkClick}>Base64 Encoder</Link>
              <Link to="/url-encoder" className={currentPath === '/url-encoder' ? 'active' : ''} onClick={handleLinkClick}>URL Encoder</Link>
              <Link to="/jwt-decoder" className={currentPath === '/jwt-decoder' ? 'active' : ''} onClick={handleLinkClick}>JWT Decoder</Link>
              <Link to="/hash-generator" className={currentPath === '/hash-generator' ? 'active' : ''} onClick={handleLinkClick}>Hash Generator</Link>
            </div>
          </div>
          
          {/* Generators Dropdown */}
          <div 
            className="dropdown-container dropdown-right" 
            onMouseEnter={() => handleMouseEnter('generators')}
            onMouseLeave={handleMouseLeave}
          >
            <div
              className={`dropdown-trigger ${activeDropdown === 'generators' || isDropdownActive('generators') ? 'active' : ''}`}
              onClick={() => toggleDropdown('generators')}
            >
              Generators
              <span className="dropdown-arrow">▼</span>
            </div>
            <div className={`dropdown-menu dropdown-menu-right ${activeDropdown === 'generators' ? 'active' : ''}`}>
              <Link to="/uuid-generator" className={currentPath === '/uuid-generator' ? 'active' : ''} onClick={handleLinkClick}>UUID Generator</Link>
              <Link to="/password-generator" className={currentPath === '/password-generator' ? 'active' : ''} onClick={handleLinkClick}>Password Generator</Link>
              <Link to="/qr-code-generator" className={currentPath === '/qr-code-generator' ? 'active' : ''} onClick={handleLinkClick}>QR Code Generator</Link>
            </div>
          </div>
          
          {/* Developer Tools Dropdown */}
          <div 
            className="dropdown-container dropdown-right" 
            onMouseEnter={() => handleMouseEnter('dev-tools')}
            onMouseLeave={handleMouseLeave}
          >
            <div
              className={`dropdown-trigger ${activeDropdown === 'dev-tools' || isDropdownActive('dev-tools') ? 'active' : ''}`}
              onClick={() => toggleDropdown('dev-tools')}
            >
              Dev Utilities
              <span className="dropdown-arrow">▼</span>
            </div>
            <div className={`dropdown-menu dropdown-menu-right ${activeDropdown === 'dev-tools' ? 'active' : ''}`}>
              <Link to="/http-status-checker" className={currentPath === '/http-status-checker' ? 'active' : ''} onClick={handleLinkClick}>HTTP Status Checker</Link>
              <Link to="/regex-tester" className={currentPath === '/regex-tester' ? 'active' : ''} onClick={handleLinkClick}>Regex Tester</Link>
              <Link to="/text-diff-checker" className={currentPath === '/text-diff-checker' ? 'active' : ''} onClick={handleLinkClick}>Text Diff Checker</Link>
              <Link to="/text-replacer" className={currentPath === '/text-replacer' ? 'active' : ''} onClick={handleLinkClick}>Text Replacer</Link>
              <Link to="/javascript-compressor" className={currentPath === '/javascript-compressor' ? 'active' : ''} onClick={handleLinkClick}>JavaScript Compressor</Link>
              <Link to="/css-compressor" className={currentPath === '/css-compressor' ? 'active' : ''} onClick={handleLinkClick}>CSS Compressor</Link>
              <Link to="/csharp-to-json" className={currentPath === '/csharp-to-json' ? 'active' : ''} onClick={handleLinkClick}>C# Class to JSON</Link>
            </div>
          </div>
          
          {/* AI Dropdown */}
          <div 
            className="dropdown-container dropdown-right" 
            onMouseEnter={() => handleMouseEnter('ai')}
            onMouseLeave={handleMouseLeave}
          >
            <div
              className={`dropdown-trigger ${activeDropdown === 'ai' || isDropdownActive('ai') ? 'active' : ''}`}
              onClick={() => toggleDropdown('ai')}
            >
              AI
              <span className="dropdown-arrow">▼</span>
            </div>
            <div className={`dropdown-menu dropdown-menu-right ${activeDropdown === 'ai' ? 'active' : ''}`}>
              <Link to="/json-to-toon" className={currentPath === '/json-to-toon' ? 'active' : ''} onClick={handleLinkClick}>JSON to TOON</Link>
              <Link to="/template-prompts" className={currentPath === '/template-prompts' ? 'active' : ''} onClick={handleLinkClick}>Template Prompts</Link>
            </div>
          </div>
        </div>
      </nav>
      <style>{`
        .navbar-hamburger {
          background: none;
          border: none;
          display: none;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          padding: 0;
        }
        .navbar-links {
          display: flex;
          gap: 1.2rem;
        }
        .navbar-links a {
          color: #fff;
          text-decoration: none;
          font-size: 1.08rem;
          padding: 0.3rem 0.2rem;
          border-bottom: 2px solid transparent;
          transition: border 0.2s;
        }
        .navbar-links a.active {
          border-bottom: 2px solid #61DAFB;
        }
        
        /* Dropdown Styles */
        .dropdown-container {
          position: relative;
        }
        .dropdown-trigger {
          color: #fff;
          text-decoration: none;
          font-size: 1.08rem;
          padding: 0.3rem 0.2rem;
          cursor: pointer;
          display: flex;
          align-items: center;
          border-bottom: 2px solid transparent;
          transition: border 0.2s;
        }
        .dropdown-trigger.active,
        .dropdown-container:hover .dropdown-trigger {
          border-bottom: 2px solid #61DAFB;
        }
        .dropdown-arrow {
          font-size: 0.7rem;
          margin-left: 5px;
        }
        .dropdown-menu {
          display: none;
          position: absolute;
          top: 100%;
          left: 0;
          min-width: 200px;
          background: #222;
          flex-direction: column;
          border-radius: 4px;
          overflow: hidden;
          z-index: 10;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        }
        .dropdown-menu-right {
          left: auto;
          right: 0;
        }
        .dropdown-menu.active {
          display: flex;
        }
        .dropdown-menu a {
          padding: 0.7rem 1rem;
          font-size: 1rem;
          border-bottom: 1px solid #333;
          white-space: nowrap;
          color: #fff;
        }
        .dropdown-menu a:hover {
          background: #2a2a2a;
        }
        
        @media (max-width: 900px) {
          .navbar-hamburger {
            display: flex;
            margin-left: auto;
          }
          .navbar-links {
            display: none;
            position: absolute;
            top: 100%;
            left: 0;
            width: 100vw;
            background: #222;
            flex-direction: column;
            gap: 0;
            z-index: 100;
            box-shadow: 0 4px 16px rgba(0,0,0,0.08);
          }
          .navbar-links.open {
            display: flex;
          }
          .dropdown-trigger {
            padding: 1rem 1.5rem;
            border-bottom: 1px solid #333;
            font-size: 1.1rem;
          }
          .dropdown-menu, .dropdown-menu-right {
            position: static;
            width: 100%;
            box-shadow: none;
            background: #1a1a1a;
          }
          .dropdown-menu a {
            padding-left: 2.5rem;
          }
        }
      `}</style>
    </div>
  );
};

export default Navbar; 